"use client";

import React, { useState, useEffect } from "react";
import "./My_Account.css";
import { useNavigate } from "react-router-dom";

import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Left_Tabs from "./left-tabs/Left_Tabs";

import Personal_Info from "./all_tabs/personal_info/Personal_Info";
import Ordered from "./all_tabs/ordered/Ordered";
import Wallet from "./all_tabs/wallet/Wallet";
import Order_History from "./all_tabs/order-history/Order_History";

import Order_Details from "./all_tabs/order-details/Order_Details";
import AppointmentHistory from "./all_tabs/appointment_history/AppointmentHistory";
import GreenStrip from "../common-components/common_green_strip/GreenStrip";
import { OrderStatusIds } from "../../utils/common";
import CancelledOrders from "./all_tabs/CancelledOrders/CancelledOrders";
import Cancelled_Order_Details from "./all_tabs/cancelled-order-details/Cancelled_Order_Details";

const My_Account = () => {
  // const [selectedTab, setSelectedTab] = useState("Profile");
  const [selectedTab, setSelectedTab] = useState(() => {
    return localStorage.getItem("my_account_active_tab") || "Profile";
  });

  const [selectedOrder, setSelectedOrder] = useState(null);
  const navigate = useNavigate();
  const [orderSection, setOrderSection] = useState("OrderList");

  const [historySection, setHistorySection] = useState("OrderList");
  const [paymentMSection, setPaymentMSection] = useState("PaymentMethod");

  const [cancelledSection, setCancelledSection] = useState(
    "CancelledOrderList",
  );

  const handleOpenOrderDetails = (order) => {
    setSelectedOrder(order);

    if (selectedTab === "Order") {
      setOrderSection("OrderDetails");
    }

    if (selectedTab === "Order History") {
      setHistorySection("OrderDetails");
    }
  };
  useEffect(() => {
    localStorage.setItem("my_account_active_tab", selectedTab);
  }, [selectedTab]);

  const handleOpenCancelledOrderDetails = (order) => {
    setSelectedOrder(order);

    if (selectedTab === "Cancelled Orders") {
      setCancelledSection("CancelledOrderDetails");
    }
  };

  return (
    <section className="My_Account">
      {" "}
      <GreenStrip heading={selectedTab} />
      <div className="container">
        <div className="back_holder" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} className="back_icon" />
          <span>Back</span>
        </div>
      </div>
      <div className="container">
        <div className="main_content_div">
          <div className="row">
            {/* LEFT SIDE */}
            <div className="col-lg-3  p-0">
              <div className="tabs_holder_div">
                <Left_Tabs setSelectedTab={setSelectedTab} />
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="col-lg-9 p-0">
              <div className="tabs_container">
                {selectedTab === "Profile" && <Personal_Info />}

                {selectedTab === "Wallet" && <Wallet />}

                {selectedTab === "Appointment History" && (
                  <AppointmentHistory />
                )}
                {selectedTab === "Order History" && (
                  <>
                    {historySection === "OrderList" && (
                      <Order_History
                        type="History"
                        onOpenOrderDetails={handleOpenOrderDetails}
                      />
                    )}

                    {historySection === "OrderDetails" && (
                      <Order_Details
                        selectedOrder={selectedOrder}
                        showBackButton={true}
                        goBack={() => setHistorySection("OrderList")}
                      />
                    )}
                  </>
                )}

                {selectedTab === "Order" && (
                  <>
                    {orderSection === "OrderList" && (
                      <Ordered
                        type="Ordered"
                        onOpenOrderDetails={handleOpenOrderDetails}
                      />
                    )}

                    {orderSection === "OrderDetails" && (
                      <Order_Details
                        selectedOrder={selectedOrder}
                        showBackButton={false}
                        showCheckBox={
                          selectedOrder?.order_status_id ===
                          OrderStatusIds.Processing
                        }
                        goBack={() => setOrderSection("OrderList")}
                      />
                    )}
                  </>
                )}

                {selectedTab === "Cancelled Orders" && (
                  <>
                    {cancelledSection === "CancelledOrderList" && (
                      <CancelledOrders
                        type="History"
                        onOpenOrderDetails={handleOpenCancelledOrderDetails}
                      />
                    )}

                    {cancelledSection === "CancelledOrderDetails" && (
                      <Cancelled_Order_Details
                        selectedOrder={selectedOrder}
                        showBackButton={true}
                        goBack={() => setCancelledSection("CancelledOrderList")}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default My_Account;
